export default __webpack_public_path__ + "images/logo-colored_2fdf14.svg";